module.exports = __webpack_public_path__ + "img/simple_arrow_next_black.9823e51d.svg";